import { AppearanceToggle } from '@/components/appearance-toggle'
import { yeshumanContentColumn } from '@/components/landing/yeshuman/yeshuman-layout'
import { yeshumanAnn, yeshumanAnnDim } from '@/components/landing/yeshuman/yeshuman-typography'
import { cn } from '@/lib/utils'
import { useGuestSurfaceTheme } from '@/hooks/use-guest-surface-theme'

export function YeshumanMarketingFooter() {
  const { guestTheme, guestPreference, setGuestTheme, themeToggleEnabled } = useGuestSurfaceTheme()

  return (
    <footer className="yeshuman-close border-t border-[var(--marketing-border)]">
      <div className={cn(yeshumanContentColumn, yeshumanAnn, yeshumanAnnDim)}>
        <div className="flex items-center justify-between gap-4 py-7">
          <span>© 2026 Yes Human</span>
          {themeToggleEnabled ? (
            <span className="md:hidden">
              <AppearanceToggle
                variant="marketing"
                size="compact"
                marketingTheme={guestTheme}
                marketingPreference={guestPreference}
                onMarketingThemeChange={setGuestTheme}
              />
            </span>
          ) : null}
        </div>
      </div>
    </footer>
  )
}
